import { defineMessages } from 'react-intl';

export default defineMessages({
    laterality: {
        id: 'constants.laterality',
        defaultMessage: 'Lateralidade'
    },
    bilateral: {
        id: 'constants.bilateral',
        defaultMessage: 'Bilateral'
    },
    right: {
        id: 'constants.right',
        defaultMessage: 'Direita'
    },
    left: {
        id: 'constants.left',
        defaultMessage: 'Esquerda'
    },
    positioning: {
        id: 'constants.positioning',
        defaultMessage: 'Posicionamento'
    },
    seated: {
        id: 'constants.seated',
        defaultMessage: 'Sentado'
    },
    orthostatic: {
        id: 'constants.orthostatic',
        defaultMessage: 'Ortostático'
    },
    dorsal: {
        id: 'constants.dorsal',
        defaultMessage: 'Decúbito Dorsal'
    },
    ventral: {
        id: 'constants.ventral',
        defaultMessage: 'Decúbito Ventral'
    },
    lateral: {
        id: 'constants.lateral',
        defaultMessage: 'Decúbito Lateral'
    },
    series: {
        id: 'constants.series',
        defaultMessage: 'Séries'
    },
    repetitions: {
        id: 'constants.repetitions',
        defaultMessage: 'Repetições'
    },
    break: {
        id: 'constants.break',
        defaultMessage: 'Intervalo / Descanso'
    },
    charge: {
        id: 'constants.charge',
        defaultMessage: 'Carga'
    },
    resistance: {
        id: 'constants.resistance',
        defaultMessage: 'Resistência'
    },
    extraLight: {
        id: 'constants.extraLight',
        defaultMessage: 'Extra leve'
    },
    light: {
        id: 'constants.light',
        defaultMessage: 'Leve'
    },
    moderate: {
        id: 'constants.moderate',
        defaultMessage: 'Moderada'
    },
    strong: {
        id: 'constants.strong',
        defaultMessage: 'Forte'
    },
    extraStrong: {
        id: 'constants.extraStrong',
        defaultMessage: 'Extra Forte'
    },
    ultraStrong: {
        id: 'constants.ultraStrong',
        defaultMessage: 'Ultra Forte'
    },
    pression: {
        id: 'constants.pression',
        defaultMessage: 'Pressão'
    },
    ipap: {
        id: 'constants.ipap',
        defaultMessage: 'IPAP'
    },
    epap: {
        id: 'constants.epap',
        defaultMessage: 'EPAP'
    },
    slope: {
        id: 'constants.slope',
        defaultMessage: 'Inclinação'
    },
    time: {
        id: 'constants.time',
        defaultMessage: 'Tempo'
    },
    speed: {
        id: 'constants.speed',
        defaultMessage: 'Velocidade'
    },
    distance: {
        id: 'constants.distance',
        defaultMessage: 'Distância'
    },
    steps: {
        id: 'constants.steps',
        defaultMessage: 'Degraus'
    },
    oxygen: {
        id: 'constants.oxygen',
        defaultMessage: 'Oxigênio'
    },
    pulse: {
        id: 'constants.pulse',
        defaultMessage: 'Largura de Pulso'
    },
    frequency: {
        id: 'constants.frequency',
        defaultMessage: 'Frequência'
    },
    intensity: {
        id: 'constants.intensity',
        defaultMessage: 'Intensidade'
    },
    exerciseStatus: {
        id: 'constants.exerciseStatus',
        defaultMessage: 'Status do Exercício'
    },
    realized: {
        id: 'constants.realized',
        defaultMessage: 'Realizado'
    },
    unrealized: {
        id: 'constants.unrealized',
        defaultMessage: 'Não Realizado'
    },
    initialFC: {
        id: 'constants.initialFC',
        defaultMessage: 'FC Inicial'
    },
    finalFC: {
        id: 'constants.finalFC',
        defaultMessage: 'FC Final'
    },
    maxFC: {
        id: 'constants.maxFC',
        defaultMessage: 'FC Máxima'
    },
    targetFC: {
        id: 'constants.targetFC',
        defaultMessage: 'FC Alvo'
    },
    initialPas: {
        id: 'constants.initialPas',
        defaultMessage: 'PAS Inicial'
    },
    initialPad: {
        id: 'constants.initialPad',
        defaultMessage: 'PAD Inicial'
    },
    finalPas: {
        id: 'constants.finalPas',
        defaultMessage: 'PAS Final'
    },
    finalPad: {
        id: 'constants.finalPad',
        defaultMessage: 'PAD Final'
    },
    initialSPO2: {
        id: 'constants.initialSPO2',
        defaultMessage: 'SpO2 Inicial'
    },
    finalSPO2: {
        id: 'constants.finalSPO2',
        defaultMessage: 'SpO2 Final'
    },
    initialBloodGlucose: {
        id: 'constants.initialBloodGlucose',
        defaultMessage: 'Glicemia Inicial'
    },
    finalBloodGlucose: {
        id: 'constants.finalBloodGlucose',
        defaultMessage: 'Glicemia Final'
    },
    initialBorg: {
        id: 'constants.initialBorg',
        defaultMessage: 'Escala de Borg Inicial'
    },
    finalBorg: {
        id: 'constants.finalBorg',
        defaultMessage: 'Escala de Borg Final'
    },
    observation: {
        id: 'constants.observation',
        defaultMessage: 'Observação'
    },
    number: {
        id: 'constants.number',
        defaultMessage: 'Número'
    },
    hour: {
        id: 'constants.hour',
        defaultMessage: 'Hora'
    },
    period: {
        id: 'constants.period',
        defaultMessage: 'Período'
    },
    text: {
        id: 'constants.text',
        defaultMessage: 'Texto'
    },
    optionList: {
        id: 'constants.optionList',
        defaultMessage: 'Lista de Opções'
    },
    simpleSelection: {
        id: 'constants.simpleSelection',
        defaultMessage: 'Seleção Simples'
    },
    dateTime: {
        id: 'constants.dateTime',
        defaultMessage: 'Data e Hora'
    },
    date: {
        id: 'constants.date',
        defaultMessage: 'Data'
    },
    professional: {
        id: 'constants.professional',
        defaultMessage: 'Profissional'
    },
    patient: {
        id: 'constants.patient',
        defaultMessage: 'Paciente'
    },
    file: {
        id: 'constants.file',
        defaultMessage: 'Arquivo'
    },
    images: {
        id: 'constants.images',
        defaultMessage: 'Imagens e Fotos'
    },
    infoLabel: {
        id: 'constants.infoLabel',
        defaultMessage: 'Rótulo de Informação'
    },
    table: {
        id: 'constants.table',
        defaultMessage: 'Tabela'
    },
    multipleChoice: {
        id: 'constants.multipleChoice',
        defaultMessage: 'Múltipla Escolha'
    },
    exam: {
        id: 'constants.exam',
        defaultMessage: 'Exame'
    },
    exercise: {
        id: 'constants.exercise',
        defaultMessage: 'Exercício'
    },
    report: {
        id: 'constants.report',
        defaultMessage: 'Relatório'
    },
    numericScale: {
        id: 'constants.numericScale',
        defaultMessage: 'Escala Numérica'
    },
    calculation: {
        id: 'constants.calculation',
        defaultMessage: 'Cálculo'
    },
    chart: {
        id: 'constants.chart',
        defaultMessage: 'Gráfico'
    },
    bodyMap: {
        id: 'constants.bodyMap',
        defaultMessage: 'Mapa Corporal'
    },
    objectives: {
        id: 'constants.objectives',
        defaultMessage: 'Objetivos'
    },
    name: {
        id: 'constants.name',
        defaultMessage: 'Nome'
    },
    email: {
        id: 'constants.email',
        defaultMessage: 'E-mail'
    },
    cpf: {
        id: 'constants.cpf',
        defaultMessage: 'CPF'
    },
    rg: {
        id: 'constants.rg',
        defaultMessage: 'RG'
    },
    birthdate: {
        id: 'constants.birthdate',
        defaultMessage: 'Data de Nascimento'
    },
    sex: {
        id: 'constants.sex',
        defaultMessage: 'Sexo'
    },
    phone: {
        id: 'constants.phone',
        defaultMessage: 'Telefone'
    },
    cellphone: {
        id: 'constants.cellphone',
        defaultMessage: 'Celular'
    },
    address: {
        id: 'constants.address',
        defaultMessage: 'Endereço'
    },
    addressNumber: {
        id: 'constants.addressNumber',
        defaultMessage: 'Número'
    },
    addressComplement: {
        id: 'constants.addressComplement',
        defaultMessage: 'Complemento'
    },
    cep: {
        id: 'constants.cep',
        defaultMessage: 'CEP'
    },
    neighborhood: {
        id: 'constants.neighborhood',
        defaultMessage: 'Bairro'
    },
    city: {
        id: 'constants.city',
        defaultMessage: 'Cidade'
    },
    state: {
        id: 'constants.state',
        defaultMessage: 'Estado'
    },
    fullAddress: {
        id: 'constants.fullAddress',
        defaultMessage: 'Endereço completo'
    },
    profession: {
        id: 'constants.profession',
        defaultMessage: 'Profissão'
    },
    numericDate: {
        id: 'constants.numericDate',
        defaultMessage: 'Data formato numérico'
    },
    textDate: {
        id: 'constants.textDate',
        defaultMessage: 'Data formato texto'
    },
    specialty: {
        id: 'constants.specialty',
        defaultMessage: 'Especialidade'
    },
    council: {
        id: 'constants.council',
        defaultMessage: 'Conselho'
    },
    councilRegister: {
        id: 'constants.councilRegister',
        defaultMessage: 'Registro conselho'
    },
    councilState: {
        id: 'constants.councilState',
        defaultMessage: 'UF do conselho'
    },
    councilRegion: {
        id: 'constants.councilRegion',
        defaultMessage: 'Número região do conselho'
    },
    professionalData: {
        id: 'constants.professionalData',
        defaultMessage: 'Dados profissional'
    },
    termSignature: {
        id: 'constants.termSignature',
        defaultMessage: 'Entendo que o USECORE usa meu nome, endereço de e-mail, CPF, número de celular e outras informações limitadas para concluir o processo de assinatura e melhorar a experiência do usuário. Para saber mais sobre como a USECORE usa as informações, consulte nossa Política de Privacidade. Ao assinar este documento com uma assinatura eletrônica, concordo com a política de privacidade da USECORE e que tal assinatura será tão válida quanto as assinaturas manuscritas e considerada original na medida permitida pela lei aplicável.'
    },
    notAttended: {
        id: 'constants.notAttended',
        defaultMessage: 'Não Atendido'
    },
    absence: {
        id: 'constants.absence',
        defaultMessage: 'Falta'
    },
    refused: {
        id: 'constants.refused',
        defaultMessage: 'Recusado'
    },
    clinicalDischarge: {
        id: 'constants.clinicalDischarge',
        defaultMessage: 'Dispensa Clínica'
    },
    numbness: {
        id: 'constants.painMap.numbness',
        defaultMessage: 'Adormecimento / Dormência'
      },
      sharp: {
        id: 'constants.painMap.sharp',
        defaultMessage: 'Afiado'
      },
      pinPrick: {
        id: 'constants.painMap.pinPrick',
        defaultMessage: 'Alfinetada e Agulhada / Alfinetes / Agulhas'
      },
      tightness: {
        id: 'constants.painMap.tightness',
        defaultMessage: 'Aperto'
      },
      heat: {
        id: 'constants.painMap.heat',
        defaultMessage: 'Calor'
      },
      electricShock: {
        id: 'constants.painMap.electricShock',
        defaultMessage: 'Choque elétrico'
      },
      itching: {
        id: 'constants.painMap.itching',
        defaultMessage: 'Coceira'
      },
      tiredPain: {
        id: 'constants.painMap.tiredPain',
        defaultMessage: 'Dor Cansada'
      },
      achingPain: {
        id: 'constants.painMap.achingPain',
        defaultMessage: 'Dor dolorida'
      },
      stingingPain: {
        id: 'constants.painMap.stingingPain',
        defaultMessage: 'Dor em Ferroada'
      },
      twitchingPain: {
        id: 'constants.painMap.twitchingPain',
        defaultMessage: 'Dor em Fisgada'
      },
      stabbingPain: {
        id: 'constants.painMap.stabbingPain',
        defaultMessage: 'Dor em pontada / Pontadas'
      },
      burningPain: {
        id: 'constants.painMap.burningPain',
        defaultMessage: 'Dor em Queimação'
      },
      explosivePain: {
        id: 'constants.painMap.explosivePain',
        defaultMessage: 'Dor explosiva'
      },
      throbbing: {
        id: 'constants.painMap.throbbing',
        defaultMessage: 'Dor Latejante'
      },
      poorlyLocalized: {
        id: 'constants.painMap.poorlyLocalized',
        defaultMessage: 'Dor mal localizada'
      },
      heavyPain: {
        id: 'constants.painMap.heavyPain',
        defaultMessage: 'Dor Pesada'
      },
      deepPain: {
        id: 'constants.painMap.deepPain',
        defaultMessage: 'Dor profunda'
      },
      pulsatingPain: {
        id: 'constants.painMap.pulsatingPain',
        defaultMessage: 'Dor Pulsante'
      },
      dullPain: {
        id: 'constants.painMap.dullPain',
        defaultMessage: 'Dor sem brilho'
      },
      stabbing: {
        id: 'constants.painMap.stabbing',
        defaultMessage: 'Facada'
      },
      tingling: {
        id: 'constants.painMap.tingling',
        defaultMessage: 'Formigamento / Sensação de formigamento'
      },
      burning: {
        id: 'constants.painMap.burning',
        defaultMessage: 'Queimação'
      },
      stiffness: {
        id: 'constants.painMap.stiffness',
        defaultMessage: 'Rigidez'
      },
      coldPain: {
        id: 'constants.painMap.coldPain',
        defaultMessage: 'Sensação de frio dolorosa / Frio'
      },
      touchPain: {
        id: 'constants.painMap.touchPain',
        defaultMessage: 'Sensação desagradável e/ou dolorosa ao toque leve'
      },
      reducedSensation: {
        id: 'constants.painMap.reducedSensation',
        defaultMessage: 'Sensação reduzida ou perdida'
      },
      otherSymptoms: {
        id: 'constants.painMap.otherSymptoms',
        defaultMessage: 'Outros sinais e sintomas'
      },
      brazil: {
        id: 'constants.brazil',
        defaultMessage: 'Brasil'
      },
      portugal: {
        id: 'constants.portugal',
        defaultMessage: 'Portugal'
      },
      unitedStates: {
        id: 'constants.unitedStates',
        defaultMessage: 'Estados Unidos'
      },
      canada: {
        id: 'constants.canada',
        defaultMessage: 'Canadá'
      },
      argentina: {
        id: 'constants.argentina',
        defaultMessage: 'Argentina'
      },
      chile: {
        id: 'constants.chile',
        defaultMessage: 'Chile'
      },
      colombia: {
        id: 'constants.colombia',
        defaultMessage: 'Colômbia'
      },
      peru: {
        id: 'constants.peru',
        defaultMessage: 'Peru'
      },
      paraguay: {
        id: 'constants.paraguay',
        defaultMessage: 'Paraguai'
      },
      uruguay: {
        id: 'constants.uruguay',
        defaultMessage: 'Uruguai'
      },
      bolivia: {
        id: 'constants.bolivia',
        defaultMessage: 'Bolívia'
      },
      ecuador: {
        id: 'constants.ecuador',
        defaultMessage: 'Equador'
      },
      venezuela: {
        id: 'constants.venezuela',
        defaultMessage: 'Venezuela'
      },
      unitedKingdom: {
        id: 'constants.unitedKingdom',
        defaultMessage: 'Reino Unido'
      },
      ireland: {
        id: 'constants.ireland',
        defaultMessage: 'Irlanda'
      },
      australia: {
        id: 'constants.australia',
        defaultMessage: 'Austrália'
      },
      newZealand: {
        id: 'constants.newZealand',
        defaultMessage: 'Nova Zelândia'
      },
      southAfrica: {
        id: 'constants.southAfrica',
        defaultMessage: 'África do Sul'
      },
      nigeria: {
        id: 'constants.nigeria',
        defaultMessage: 'Nigéria'
      },
      india: {
        id: 'constants.india',
        defaultMessage: 'Índia'
      },
      china: {
        id: 'constants.china',
        defaultMessage: 'China'
      },
      japan: {
        id: 'constants.japan',
        defaultMessage: 'Japão'
      },
      southKorea: {
        id: 'constants.southKorea',
        defaultMessage: 'Coreia do Sul'
      },
      philippines: {
        id: 'constants.philippines',
        defaultMessage: 'Filipinas'
      },
      saudiArabia: {
        id: 'constants.saudiArabia',
        defaultMessage: 'Arábia Saudita'
      },
      unitedArabEmirates: {
        id: 'constants.unitedArabEmirates',
        defaultMessage: 'Emirados Árabes Unidos'
      },
      iran: {
        id: 'constants.iran',
        defaultMessage: 'Irã'
      },
      israel: {
        id: 'constants.israel',
        defaultMessage: 'Israel'
      },
      romania: {
        id: 'constants.romania',
        defaultMessage: 'Romênia'
      },
      poland: {
        id: 'constants.poland',
        defaultMessage: 'Polônia'
      },
      russia: {
        id: 'constants.russia',
        defaultMessage: 'Rússia'
      },
      turkey: {
        id: 'constants.turkey',
        defaultMessage: 'Turquia'
      },
      egypt: {
        id: 'constants.egypt',
        defaultMessage: 'Egito'
      },
      kenya: {
        id: 'constants.kenya',
        defaultMessage: 'Quênia'
      },
      cpf: {
        id: 'constants.cpf',
        defaultMessage: 'CPF'
      },
      placeholderCpf: {
        id: 'constants.placeholderCpf',
        defaultMessage: 'Digite o CPF'
      },
      descriptionCpf: {
        id: 'constants.descriptionCpf',
        defaultMessage: 'Cadastro de Pessoa Física'
      },
      rg: {
        id: 'constants.rg',
        defaultMessage: 'RG'
      },
      placeholderRg: {
        id: 'constants.placeholderRg',
        defaultMessage: 'Digite o RG'
      },
      descriptionRg: {
        id: 'constants.descriptionRg',
        defaultMessage: 'Registro Geral / Cédula de Identidade'
      },
      nif: {
        id: 'constants.nif',
        defaultMessage: 'NIF'
      },
      placeholderNif: {
        id: 'constants.placeholderNif',
        defaultMessage: 'Digite o NIF'
      },
      descriptionNif: {
        id: 'constants.descriptionNif',
        defaultMessage: 'Número de Identificação Fiscal'
      },
      ssn: {
        id: 'constants.ssn',
        defaultMessage: 'SSN'
      },
      placeholderSsn: {
        id: 'constants.placeholderSsn',
        defaultMessage: 'Digite o SSN'
      },
      descriptionSsn: {
        id: 'constants.descriptionSsn',
        defaultMessage: 'Social Security Number'
      },
      sin: {
        id: 'constants.sin',
        defaultMessage: 'SIN'
      },
      placeholderSin: {
        id: 'constants.placeholderSin',
        defaultMessage: 'Digite o SIN'
      },
      descriptionSin: {
        id: 'constants.descriptionSin',
        defaultMessage: 'Social Insurance Number'
      },
      dni: {
        id: 'constants.dni',
        defaultMessage: 'DNI'
      },
      placeholderDni: {
        id: 'constants.placeholderDni',
        defaultMessage: 'Digite o DNI'
      },
      descriptionDni: {
        id: 'constants.descriptionDni',
        defaultMessage: 'Documento Nacional de Identidade'
      },
      cuil: {
        id: 'constants.cuil',
        defaultMessage: 'CUIL'
      },
      placeholderCuil: {
        id: 'constants.placeholderCuil',
        defaultMessage: 'Digite o CUIL'
      },
      descriptionCuil: {
        id: 'constants.descriptionCuil',
        defaultMessage: 'Código Unificado de Identificación Laboral'
      },
      bi: {
        id: 'constants.bi',
        defaultMessage: 'BI'
      },
      placeholderBi: {
        id: 'constants.placeholderBi',
        defaultMessage: 'Digite o BI'
      },
      descriptionBi: {
        id: 'constants.descriptionBi',
        defaultMessage: 'Bilhete de Identidade'
      },
      cni: {
        id: 'constants.cni',
        defaultMessage: 'CNI'
      },
      placeholderCni: {
        id: 'constants.placeholderCni',
        defaultMessage: 'Digite o CNI'
      },
      descriptionCni: {
        id: 'constants.descriptionCni',
        defaultMessage: 'Cartão Nacional de Identidade'
      },
      curp: {
        id: 'constants.curp',
        defaultMessage: 'CURP'
      },
      placeholderCurp: {
        id: 'constants.placeholderCurp',
        defaultMessage: 'Digite o CURP'
      },
      descriptionCurp: {
        id: 'constants.descriptionCurp',
        defaultMessage: 'Clave Única de Registro de Población'
      },
      rut: {
        id: 'constants.rut',
        defaultMessage: 'RUT'
      },
      placeholderRut: {
        id: 'constants.placeholderRut',
        defaultMessage: 'Digite o RUT'
      },
      descriptionRut: {
        id: 'constants.descriptionRut',
        defaultMessage: 'Registro Unico de Tributos'
      },
      run: {
        id: 'constants.run',
        defaultMessage: 'RUN'
      },
      placeholderRun: {
        id: 'constants.placeholderRun',
        defaultMessage: 'Digite o RUN'
      },
      descriptionRun: {
        id: 'constants.descriptionRun',
        defaultMessage: 'Rol Único Nacional'
      },
      cc: {
        id: 'constants.cc',
        defaultMessage: 'CC'
      },
      placeholderCc: {
        id: 'constants.placeholderCc',
        defaultMessage: 'Digite o CC'
      },
      descriptionCc: {
        id: 'constants.descriptionCc',
        defaultMessage: 'Cédula de Ciudadanía'
      },
      ci: {
        id: 'constants.ci',
        defaultMessage: 'CI'
      },
      placeholderCi: {
        id: 'constants.placeholderCi',
        defaultMessage: 'Digite o CI'
      },
      descriptionCi: {
        id: 'constants.descriptionCi',
        defaultMessage: 'Cédula de Identidad'
      },
      nin: {
        id: 'constants.nin',
        defaultMessage: 'NIN'
      },
      placeholderNin: {
        id: 'constants.placeholderNin',
        defaultMessage: 'Digite o NIN'
      },
      descriptionNin: {
        id: 'constants.descriptionNin',
        defaultMessage: 'National Insurance Number'
      },
      ppsn: {
        id: 'constants.ppsn',
        defaultMessage: 'PPSN'
      },
      placeholderPpsn: {
        id: 'constants.placeholderPpsn',
        defaultMessage: 'Digite o PPSN'
      },
      descriptionPpsn: {
        id: 'constants.descriptionPpsn',
        defaultMessage: 'Personal Public Service Number'
      },
      medicareNumber: {
        id: 'constants.medicareNumber',
        defaultMessage: 'Medicare Number'
      },
      placeholderMedicareNumber: {
        id: 'constants.placeholderMedicareNumber',
        defaultMessage: 'Digite o Medicare Number'
      },
      descriptionMedicareNumber: {
        id: 'constants.descriptionMedicareNumber',
        defaultMessage: 'Medicare Number'
      },
      ird: {
        id: 'constants.ird',
        defaultMessage: 'IRD'
      },
      placeholderIrd: {
        id: 'constants.placeholderIrd',
        defaultMessage: 'Digite o IRD'
      },
      descriptionIrd: {
        id: 'constants.descriptionIrd',
        defaultMessage: 'Inland Revenue Department Number'
      },
      idBookSmartId: {
        id: 'constants.idBookSmartId',
        defaultMessage: 'ID Book / Smart ID'
      },
      placeholderIdBookSmartId: {
        id: 'constants.placeholderIdBookSmartId',
        defaultMessage: 'Digite o ID Book / Smart ID'
      },
      descriptionIdBookSmartId: {
        id: 'constants.descriptionIdBookSmartId',
        defaultMessage: 'ID Book / Smart ID'
      },
      bvn: {
        id: 'constants.bvn',
        defaultMessage: 'BVN'
      },
      placeholderBvn: {
        id: 'constants.placeholderBvn',
        defaultMessage: 'Digite o BVN'
      },
      descriptionBvn: {
        id: 'constants.descriptionBvn',
        defaultMessage: 'Bank Verification Number'
      },
      aadhaar: {
        id: 'constants.aadhaar',
        defaultMessage: 'Aadhaar'
      },
      placeholderAadhaar: {
        id: 'constants.placeholderAadhaar',
        defaultMessage: 'Digite o Aadhaar'
      },
      descriptionAadhaar: {
        id: 'constants.descriptionAadhaar',
        defaultMessage: 'Aadhaar'
      },
      idCard: {
        id: 'constants.idCard',
        defaultMessage: 'ID Card'
      },
      placeholderIdCard: {
        id: 'constants.placeholderIdCard',
        defaultMessage: 'Digite o ID Card'
      },
      descriptionIdCard: {
        id: 'constants.descriptionIdCard',
        defaultMessage: 'ID Card'
      },
      myNumber: {
        id: 'constants.myNumber',
        defaultMessage: 'My Number'
      },
      placeholderMyNumber: {
        id: 'constants.placeholderMyNumber',
        defaultMessage: 'Digite o My Number'
      },
      descriptionMyNumber: {
        id: 'constants.descriptionMyNumber',
        defaultMessage: 'My Number'
      },
      rrn: {
        id: 'constants.rrn',
        defaultMessage: 'RRN'
      },
      placeholderRrn: {
        id: 'constants.placeholderRrn',
        defaultMessage: 'Digite o RRN'
      },
      descriptionRrn: {
        id: 'constants.descriptionRrn',
        defaultMessage: 'RRN'
      },
      psn: {
        id: 'constants.psn',
        defaultMessage: 'PSN'
      },
      placeholderPsn: {
        id: 'constants.placeholderPsn',
        defaultMessage: 'Digite o PSN'
      },
      descriptionPsn: {
        id: 'constants.descriptionPsn',
        defaultMessage: 'PSN'
      },
      iqama: {
        id: 'constants.iqama',
        defaultMessage: 'Iqama'
      },
      placeholderIqama: {
        id: 'constants.placeholderIqama',
        defaultMessage: 'Digite o Iqama'
      },
      descriptionIqama: {
        id: 'constants.descriptionIqama',
        defaultMessage: 'Iqama'
      },
      emiratesId: {
        id: 'constants.emiratesId',
        defaultMessage: 'Emirates ID'
      },
      placeholderEmiratesId: {
        id: 'constants.placeholderEmiratesId',
        defaultMessage: 'Digite o Emirates ID'
      },
      descriptionEmiratesId: {
        id: 'constants.descriptionEmiratesId',
        defaultMessage: 'Emirates ID'
      },
      nationalId: {
        id: 'constants.nationalId',
        defaultMessage: 'National ID'
      },
      placeholderNationalId: {
        id: 'constants.placeholderNationalId',
        defaultMessage: 'Digite o National ID'
      },
      descriptionNationalId: {
        id: 'constants.descriptionNationalId',
        defaultMessage: 'National ID'
      },
      teudatZehut: {
        id: 'constants.teudatZehut',
        defaultMessage: 'Teudat Zehut'
      },
      placeholderTeudatZehut: {
        id: 'constants.placeholderTeudatZehut',
        defaultMessage: 'Digite o Teudat Zehut'
      },
      descriptionTeudatZehut: {
        id: 'constants.descriptionTeudatZehut',
        defaultMessage: 'Teudat Zehut'
      },
      cnp: {
        id: 'constants.cnp',
        defaultMessage: 'CNP'
      },
      placeholderCnp: {
        id: 'constants.placeholderCnp',
        defaultMessage: 'Digite o CNP'
      },
      descriptionCnp: {
        id: 'constants.descriptionCnp',
        defaultMessage: 'CNP'
      },
      pesel: {
        id: 'constants.pesel',
        defaultMessage: 'PESEL'
      },
      placeholderPesel: {
        id: 'constants.placeholderPesel',
        defaultMessage: 'Digite o PESEL'
      },
      descriptionPesel: {
        id: 'constants.descriptionPesel',
        defaultMessage: 'PESEL'
      },
      internalPassport: {
        id: 'constants.internalPassport',
        defaultMessage: 'Internal Passport'
      },
      placeholderInternalPassport: {
        id: 'constants.placeholderInternalPassport',
        defaultMessage: 'Digite o Internal Passport'
      },
      descriptionInternalPassport: {
        id: 'constants.descriptionInternalPassport',
        defaultMessage: 'Internal Passport'
      },
      tckn: {
        id: 'constants.tckn',
        defaultMessage: 'TCKN'
      },
      placeholderTckn: {
        id: 'constants.placeholderTckn',
        defaultMessage: 'Digite o TCKN'
      },
      descriptionTckn: {
        id: 'constants.descriptionTckn',
        defaultMessage: 'TCKN'
      },
      hudumaNamba: {
        id: 'constants.hudumaNamba',
        defaultMessage: 'Huduma Namba'
      },
      placeholderHudumaNamba: {
        id: 'constants.placeholderHudumaNamba',
        defaultMessage: 'Digite o Huduma Namba'
      },
      descriptionHudumaNamba: {
        id: 'constants.descriptionHudumaNamba',
        defaultMessage: 'Huduma Namba'
      },
  jointMobilityCervical: {
    id: 'constants.jointMobilityCervical',
    defaultMessage: 'Coluna Vertebral'
  },
  jointMobilityLumbar: {
    id: 'constants.jointMobilityLumbar',
    defaultMessage: 'Coluna lombar'
  },
  jointMobilityUpperLimbs: {
    id: 'constants.jointMobilityUpperLimbs',
    defaultMessage: 'Membros Superiores'
  },
  jointMobilityLowerLimbs: {
    id: 'constants.jointMobilityLowerLimbs',
    defaultMessage: 'Membros Inferiores'
  },
  jointMobilityShoulder: {
    id: 'constants.jointMobilityShoulder',
    defaultMessage: 'Ombro'
  },
  jointMobilityElbow: {
    id: 'constants.jointMobilityElbow',
    defaultMessage: 'Cotovelo'
  },
  jointMobilityWrist: {
    id: 'constants.jointMobilityWrist',
    defaultMessage: 'Pulso'
  },
  jointMobilityHip: {
    id: 'constants.jointMobilityHip',
    defaultMessage: 'Quadril'
  },
  jointMobilityKnee: {
    id: 'constants.jointMobilityKnee',
    defaultMessage: 'Joelho'
  },
  jointMobilityAnkle: {
    id: 'constants.jointMobilityAnkle',
    defaultMessage: 'Tornozelo'
  },
  jointMobilityLumbarRegion: {
    id: 'constants.jointMobilityLumbarRegion',
    defaultMessage: 'Lombar'
  },
  jointMobilityCervicalRegion: {
    id: 'constants.jointMobilityCervicalRegion',
    defaultMessage: 'Cervical'
  },
  // Movimentos
  jointMobilityFlexion: {
    id: 'constants.jointMobilityFlexion',
    defaultMessage: 'Flexão'
  },
  jointMobilityFlexionLateral: {
    id: 'constants.jointMobilityFlexionLateral',
    defaultMessage: 'Flexão Lateral'
  },
  jointMobilityExtension: {
    id: 'constants.jointMobilityExtension',
    defaultMessage: 'Extensão'
  },
  jointMobilityFlexionRight: {
    id: 'constants.jointMobilityFlexionRight',
    defaultMessage: 'Flexão Lateral Direita'
  },
  jointMobilityLateralFlexionLeft: {
    id: 'constants.jointMobilityLateralFlexionLeft',
    defaultMessage: 'Flexão Lateral Esquerda'
  },
  jointMobilityRotationRight: {
    id: 'constants.jointMobilityRotationRight',
    defaultMessage: 'Rotação Direita'
  },
  jointMobilityRotationLeft: {
    id: 'constants.jointMobilityRotationLeft',
    defaultMessage: 'Rotação Esquerda'
  },
  jointMobilityRotation: {
    id: 'constants.jointMobilityRotation',
    defaultMessage: 'Rotação'
  },
  jointMobilityAbduction: {
    id: 'constants.jointMobilityAbduction',
    defaultMessage: 'Abdução'
  },
  jointMobilityAdduction: {
    id: 'constants.jointMobilityAdduction',
    defaultMessage: 'Adução'
  },
  jointMobilityMedialRotation: {
    id: 'constants.jointMobilityMedialRotation',
    defaultMessage: 'Rotação Medial'
  },
  jointMobilityLateralRotation: {
    id: 'constants.jointMobilityLateralRotation',
    defaultMessage: 'Rotação Lateral'
  },
  jointMobilityHorizontalAbduction: {
    id: 'constants.jointMobilityHorizontalAbduction',
    defaultMessage: 'Abdução Horizontal'
  },
  jointMobilityHorizontalAdduction: {
    id: 'constants.jointMobilityHorizontalAdduction',
    defaultMessage: 'Adução Horizontal'
  },
  jointMobilitySupination: {
    id: 'constants.jointMobilitySupination',
    defaultMessage: 'Supinação'
  },
  jointMobilityPronation: {
    id: 'constants.jointMobilityPronation',
    defaultMessage: 'Pronação'
  },
  jointMobilityRadialDeviation: {
    id: 'constants.jointMobilityRadialDeviation',
    defaultMessage: 'Desvio Radial'
  },
  jointMobilityUlnarDeviation: {
    id: 'constants.jointMobilityUlnarDeviation',
    defaultMessage: 'Desvio Ulnar'
  },
  jointMobilityInternalRotation: {
    id: 'constants.jointMobilityInternalRotation',
    defaultMessage: 'Rotação Interna (medial)'
  },
  jointMobilityExternalRotation: {
    id: 'constants.jointMobilityExternalRotation',
    defaultMessage: 'Rotação Externa (lateral)'
  },
  jointMobilityDorsiflexion: {
    id: 'constants.jointMobilityDorsiflexion',
    defaultMessage: 'Dorsiflexão'
  },
  jointMobilityPlantarflexion: {
    id: 'constants.jointMobilityPlantarflexion',
    defaultMessage: 'PlantiFlexão'
  },
  jointMobilityInversion: {
    id: 'constants.jointMobilityInversion',
    defaultMessage: 'Inversão'
  },
  jointMobilityEversion: {
    id: 'constants.jointMobilityEversion',
    defaultMessage: 'Eversão'
  },
  jointMobilityFlexionExtension: {
    id: 'constants.jointMobilityFlexionExtension',
    defaultMessage: 'Flexão / Extensão'
  },

  active: {
    id: 'constants.active',
    defaultMessage: 'Ativo'
  },
  passive: {
    id: 'constants.passive',
    defaultMessage: 'Passivo'
  },
  activeAssisted: {
    id: 'constants.activeAssisted',
    defaultMessage: 'Ativo Assistido'
  },
  activeResisted: {
    id: 'constants.activeResisted',
    defaultMessage: 'Ativo Resistido'
  },
  pressure: {
    id: 'constants.pressure',
    defaultMessage: 'Pressão'
  },
  punch: {
    id: 'constants.punch',
    defaultMessage: 'Punção'
  },
  rigidity: {
    id: 'constants.rigidity',
    defaultMessage: 'Rigidez'
  },
  colic: {
    id: 'constants.colic',
    defaultMessage: 'Colic'
  },
  shock: {
    id: 'constants.shock',
    defaultMessage: 'Choque'
  },
  start: {
    id: 'constants.start',
    defaultMessage: 'Início'
  },
  end: {
    id: 'constants.end',
    defaultMessage: 'Fim'
  },
  middle: {
    id: 'constants.middle',
    defaultMessage: 'Meio'
  },
  during: {
    id: 'constants.during',
    defaultMessage: 'Durante'
  },
  hard: {
    id: 'constants.hard',
    defaultMessage: 'Duro',
  },
  soft: {
    id: 'constants.soft',
    defaultMessage: 'Macio',
  },
  elastic: {
    id: 'constants.elastic',
    defaultMessage: 'Elástico',
  },
  spastic: {
    id: 'constants.spastic',
    defaultMessage: 'Espástico',
  },
  empty: {
    id: 'constants.empty',
    defaultMessage: 'Vazio',
  },
  undefined: {
    id: 'constants.undefined',
    defaultMessage: 'Indefinido',
  },
  thumbExtension: {
    id: 'constants.thumbExtension',
    defaultMessage: 'Extensão do 1º dedo do polegar',
  },
  thumbInternalExtension: {
    id: 'constants.thumbInternalExtension',
    defaultMessage: 'Extensão interna do 1º dedo do polegar',
  },
  fingerInternalExtension: {
    id: 'constants.fingerInternalExtension',
    defaultMessage: 'Extensão int. 2 ao 5 dedo',
  },
  halluxFlexion: {
    id: 'constants.halluxFlexion',
    defaultMessage: 'Flexão do hálux',
  },
  halluxExtension: {
    id: 'constants.halluxExtension',
    defaultMessage: 'Extensão do hálux',
  },
  fingerFlexion25: {
    id: 'constants.fingerFlexion25',
    defaultMessage: 'Flexão do 2º ao 5º dedo',
  },
  fingerExtension25: {
    id: 'constants.fingerExtension25',
    defaultMessage: 'Extensão do 2º ao 5º dedo',
  },
  halluxFlexionI: {
    id: 'constants.halluxFlexionI',
    defaultMessage: 'Flexão (I) do hálux',
  },
  proximalInterphalangeal25: {
    id: 'constants.proximalInterphalangeal25',
    defaultMessage: 'Interfal. proximal (2º ao 5º)',
  },
  distalInterphalangeal25: {
    id: 'constants.distalInterphalangeal25',
    defaultMessage: 'Interfal. distal (2º ao 5º)',
  },
  internalRotation: {
    id: 'constants.internalRotation',
    defaultMessage: 'Rotação interna',
  },
  externalRotation: {
    id: 'constants.externalRotation',
    defaultMessage: 'Rotação externa',
  },
  radioulnar: {
    id: 'constants.radioulnar',
    defaultMessage: 'Radioulnar',
  },
  distalUpperLimbs: {
    id: 'constants.distalUpperLimbs',
    defaultMessage: 'Extremidade Distal MMSS',
  },
  wrist: {
    id: 'constants.wrist',
    defaultMessage: 'Punho',
  },
  adductionUlnarDeviation: {
    id: 'constants.adductionUlnarDeviation',
    defaultMessage: 'Adução (desvio ulnar)',
  },
  abductionRadialDeviation: {
    id: 'constants.abductionRadialDeviation',
    defaultMessage: 'Abdução (desvio radial)',
  },
  carpometacarpal: {
    id: 'constants.carpometacarpal',
    defaultMessage: 'Carpometacárpica do polegar',
  },
  metacarpophalangeal: {
    id: 'constants.metacarpophalangeal',
    defaultMessage: 'Metacarpofalangianas',
  },
  proximalInterphalangeal: {
    id: 'constants.proximalInterphalangeal',
    defaultMessage: 'Interfalângicas Proximais',
  },
  distalInterphalangeal: {
    id: 'constants.distalInterphalangeal',
    defaultMessage: 'Interfalângicas Distais',
  },
  distalLowerLimbs: {
    id: 'constants.distalLowerLimbs',
    defaultMessage: 'Extremidade Distal MMII',
  },
  dorsalFlexion: {
    id: 'constants.dorsalFlexion',
    defaultMessage: 'Flexão dorsal',
  },
  plantarFlexion: {
    id: 'constants.plantarFlexion',
    defaultMessage: 'Flexão plantar',
  },
  metatarsophalangeal: {
    id: 'constants.metatarsophalangeal',
    defaultMessage: 'Metatarsofalangianas',
  },
  interphalangeal: {
    id: 'constants.interphalangeal',
    defaultMessage: 'Interfalângicas',
  },
  atm: {
    id: 'constants.atm',
    defaultMessage: 'ATM',
  },
  mouthOpening: {
    id: 'constants.mouthOpening',
    defaultMessage: 'Abertura da boca',
  },
  normal: {
    id: 'constants.asymmetry.normal',
    defaultMessage: 'Normal',
  },
  lightAttention: {
    id: 'constants.asymmetry.lightAttention',
    defaultMessage: 'Leve',
  },
  moderate: {
    id: 'constants.asymmetry.moderate',
    defaultMessage: 'Moderada',
  },
  highSevere: {
    id: 'constants.asymmetry.highSevere',
    defaultMessage: 'Alta / Grave',
  },
  intervalLessEqual10: {
    id: 'constants.asymmetry.intervalLessEqual10',
    defaultMessage: '≤ 10%',
  },
  interval1120: {
    id: 'constants.asymmetry.interval1120',
    defaultMessage: '11 - 20%',
  },
  interval2130: {
    id: 'constants.asymmetry.interval2130',
    defaultMessage: '21 - 30%',
  },
  intervalMore30: {
    id: 'constants.asymmetry.intervalMore30',
    defaultMessage: '> 30%',
  },
  clinicalInterpretationNormal: {
    id: 'constants.asymmetry.clinicalInterpretationNormal',
    defaultMessage: 'Dentro da margem de erro + dominância',
  },
  clinicalInterpretationLight: {
    id: 'constants.asymmetry.clinicalInterpretationLight',
    defaultMessage: 'Assimetria acima do erro, mas ainda comum',
  },
  clinicalInterpretationModerate: {
    id: 'constants.asymmetry.clinicalInterpretationModerate',
    defaultMessage: 'Desvio potencialmente clínico',
  },
  clinicalInterpretationHigh: {
    id: 'constants.asymmetry.clinicalInterpretationHigh',
    defaultMessage: 'Assimetria possivelmente patológica',
  },
  recommendedConductNormal: {
    id: 'constants.asymmetry.recommendedConductNormal',
    defaultMessage: 'Seguir plano habitual e reavaliar a cada 3-6 meses',
  },
  recommendedConductLight: {
    id: 'constants.asymmetry.recommendedConductLight',
    defaultMessage: 'Exercícios de mobilidade/estabilidade específicos; reavaliar em 2-4 sem.',
  },
  recommendedConductModerate: {
    id: 'constants.asymmetry.recommendedConductModerate',
    defaultMessage: 'Programa estruturado de correção + teste semanal; investigar restrições teciduais',
  },
  recommendedConductHigh: {
    id: 'constants.asymmetry.recommendedConductHigh',
    defaultMessage: 'Avaliação completa (imagem, causas neurológicas/estruturais); intervenção intensiva ou encaminhamento',
  },
  valueLessEqual10: {
    id: 'constants.asymmetry.valueLessEqual10',
    defaultMessage: '≤ 10%',
  },
  value1120: {
    id: 'constants.asymmetry.value1120',
    defaultMessage: '11 - 20%',
  },
  value2130: {
    id: 'constants.asymmetry.value2130',
    defaultMessage: '21 - 30%',
  },
  valueMore30: {
    id: 'constants.asymmetry.valueMore30',
    defaultMessage: '> 30%',
  },
  undefined: {
    id: 'constants.asymmetry.undefined',
    defaultMessage: 'Indefinido',
  },
  complete: {
    id: 'constants.cifQualifiers.complete',
    defaultMessage: 'Completo',
  },
  severe: {
    id: 'constants.cifQualifiers.severe',
    defaultMessage: 'Grave',
  },
  moderate: {
    id: 'constants.cifQualifiers.moderate',
    defaultMessage: 'Moderado',
  },
  mild: {
    id: 'constants.cifQualifiers.mild',
    defaultMessage: 'Leve',
  },
  noProblem: {
    id: 'constants.cifQualifiers.noProblem',
    defaultMessage: 'Não há problema',
  },
  cifMuscleStrength: {
    id: 'constants.cifQualifiers.cifMuscleStrength',
    defaultMessage: 'CIF / Força Muscular - Classificação Internacional de Funcionalidade',
  },
  noPain: {
    id: 'constants.qualifiers.noPain',
    defaultMessage: 'Sem Dor',
  },
  nprs: {
    id: 'constants.qualifiers.nprs',
    defaultMessage: 'NPRS',
  },
  cifMuscleStrength: {
    id: 'constants.qualifiers.cifMuscleStrength',
    defaultMessage: 'CIF / Força Muscular - Classificação Internacional de Funcionalidade',
  },
  completeDeficiency: {
    id: 'constants.qualifiers.details.completeDeficiency',
    defaultMessage: 'Deficiência completa (96-100%)',
  },
  severeDeficiency: {
    id: 'constants.qualifiers.details.severeDeficiency',
    defaultMessage: 'Deficiência grave (50-95%)',
  },
  moderateDeficiency: {
    id: 'constants.qualifiers.details.moderateDeficiency',
    defaultMessage: 'Deficiência moderada (25-49%)',
  },
  mildDeficiency: {
    id: 'constants.qualifiers.details.mildDeficiency',
    defaultMessage: 'Deficiência leve (5-24%)',
  },
  noDeficiency: {
    id: 'constants.qualifiers.details.noDeficiency',
    defaultMessage: 'Nenhuma deficiência (0-4%)',
  },
  functionalSymmetry: {
    id: 'constants.asymmetry.functionalSymmetry',
    defaultMessage: 'Simetria funcional',
  },
  lightAsymmetry: {
    id: 'constants.asymmetry.lightAsymmetry',
    defaultMessage: 'Assimetria leve',
  },
  moderateAsymmetry: {
    id: 'constants.asymmetry.moderateAsymmetry',
    defaultMessage: 'Assimetria moderada',
  },
  severeAsymmetry: {
    id: 'constants.asymmetry.severeAsymmetry',
    defaultMessage: 'Assimetria severa',
  },
  excellent: {
    id: 'constants.excellent',
    defaultMessage: 'Excelente',
  },
  clinicalInterpretationExcellent: {
    id: 'constants.asymmetry.clinicalInterpretationExcellent',
    defaultMessage: 'Simetria ideal',
  },
  recommendedConductExcellent: {
    id: 'constants.asymmetry.recommendedConductExcellent',
    defaultMessage: 'Simetria ideal',
  },
  severeAsymmetryAbbreviation: {
    id: 'constants.asymmetry.severeAsymmetryAbbreviation',
    defaultMessage: 'Severa',
  },
  muscleStrength: {
    id: 'constants.muscleStrength',
    defaultMessage: 'Força Muscular',
  },
  jointMobility: {
    id: 'constants.jointMobility',
    defaultMessage: 'Mobilidade Articular',
  },

})
      

      
      
      